// Copyright © 2022 Vewd Software AS.
//
// This file is part of Vewd Cloud,
// and includes Vewd Confidential Information.
// Distribution is strictly prohibited without Vewd's written consent.
import { useField } from "formik";

import { getFieldTestId } from "utils/formik";

import { createMixedValidator } from ".";
import { Textarea } from "../elements";
import { FieldProps } from "./propTypes";

export const TextareaField = (props) => {
  const { name, required = true, dataTestId, validate } = props;

  const [field, meta] = useField({
    ...props,
    required,
    type: "textarea",
    validate: createMixedValidator(name, required, validate),
  });

  return (
    <Textarea
      {...field}
      {...meta}
      {...props}
      isFormik={true}
      required={required}
      dataTestId={dataTestId || getFieldTestId(name)}
    />
  );
};

TextareaField.propTypes = FieldProps;
